"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichTextLegacy = exports.RichTextContent = exports.RichTextLegacyContent = exports.isRichTextContent = exports.RichTextContentType = void 0;
const tslib_1 = require("tslib");
const fp_ts_1 = require("fp-ts");
const function_1 = require("fp-ts/lib/function");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const utils_1 = require("../../../utils");
const Blocks_1 = require("./Blocks");
exports.RichTextContentType = "StructuredTextContent";
const isRichTextContent = (u) => (0, utils_1.hasContentType)(u) && u.__TYPE__ === exports.RichTextContentType;
exports.isRichTextContent = isRichTextContent;
exports.RichTextLegacyContent = t.array(Blocks_1.BlockLegacy);
exports.RichTextContent = t.strict({
    __TYPE__: t.literal(exports.RichTextContentType),
    value: t.array(Blocks_1.Block),
});
(0, tslib_1.__exportStar)(require("./Blocks"), exports);
const RichTextLegacy = (ctx) => new t.Type("RichTextLegacy", exports.isRichTextContent, (u) => {
    return (0, function_1.pipe)(exports.RichTextLegacyContent.decode(u), fp_ts_1.either.map((r) => ({ value: r, __TYPE__: exports.RichTextContentType })));
}, (r) => {
    return {
        content: exports.RichTextLegacyContent.encode(r.value),
        types: { [ctx.keyOfType]: "StructuredText" },
    };
});
exports.RichTextLegacy = RichTextLegacy;
